import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e6981a9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "smstemplate" }
const _hoisted_2 = {
  class: "modal-title",
  id: "smstemplate-modal-label"
}
const _hoisted_3 = { class: "report-items" }
const _hoisted_4 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = {
  id: "status-bar-actions",
  style: {"margin-left":"auto"}
}
const _hoisted_10 = { class: "text-light" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Secondary Actions"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" }, null, -1))
const _hoisted_16 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Primary Actions"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "fas fa-save"
}

import { computed, inject, ref, watch, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from "vue-toastification";
import { SMSTemplate, Dictionary } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const isSaving = ref(false);

const store = useStore();
const toast = useToast();
const router = useRouter();
const route = useRoute();

const smstemplate = computed((): SMSTemplate => store.getters['smstemplates/current']);
const hasUnsavedChanges = computed(() => store.getters['smstemplates/hasUnsavedChanges']);

const actProperty: any = inject('actProperty');

const setSMSTemplate = (smstemplate: SMSTemplate): void => {
  store.commit('smstemplates/setSMSTemplate', smstemplate);
};

const getSMSTemplate = (id: string): Promise<SMSTemplate> => {
  return store.dispatch('smstemplates/getSMSTemplate', id);
};

const addSMSTemplate = (smstemplate: SMSTemplate): Promise<SMSTemplate> => {
  return store.dispatch('smstemplates/addSMSTemplate', smstemplate);
};

const updateSMSTemplate = (smstemplate: SMSTemplate): Promise<SMSTemplate> => {
  return store.dispatch('smstemplates/updateSMSTemplate', smstemplate);
};

const resetUnsavedChanges = (): void => {
  store.commit('smstemplates/resetUnsavedChanges');
};

// Lifecycle hooks
onMounted(async () => {
  resetUnsavedChanges();
  if (isNewTemplate()) {
    setSMSTemplate(new SMSTemplate());
    return;
  }
  await getSMSTemplate(route.params.id as string)
    .then((smstemplate: SMSTemplate) => {
      if (smstemplate === undefined) {
        actProperty.displayError(
          `Could not find smstemplate with ID ${route.params.id as string}`
        );
        router.push({ name: "smstemplates" });
      }
    })
    .catch((err: any) => actProperty.displayError(err));
});

const isNewTemplate = () => {
  return route.params.id == "new";
};

const canSave = () => {
  return smstemplate.value.body;
};

const save = async () => {
  if (canSave()) {
      if (isNewTemplate()) {
        addSMSTemplate(smstemplate.value).then(
          (smstemplate: SMSTemplate) => {
            toast.success(`Saved`);
            router.push({
              name: "smstemplate",
              params: { id: smstemplate.id },
            });
          }
        );
      } else {
        updateSMSTemplate(smstemplate.value).then(
          (smstemplate: SMSTemplate) => {
            router.push({ name: "smstemplates" });
          }
        );
      }
    }
};

const cancel = () => {
  resetUnsavedChanges();
  router.back();
};


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, " SMS template: " + _toDisplayString(smstemplate.value.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'sms-template-details'},
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Template ")
            ]),
            _: 1
          })
        ]),
        (!isNewTemplate() && !smstemplate.value.defaulttemplate)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: {name: 'sms-template-clients',params: {search: _unref(route).params.search || 'a'}},
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Customers ")
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "You have unsaved changes"))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, "No unsaved changes")),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-outline-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (cancel()), ["prevent"])),
                disabled: !hasUnsavedChanges.value
              }, [
                _hoisted_15,
                _createTextVNode(" Cancel ")
              ], 10, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (save()), ["prevent"])),
                disabled: isSaving.value || !hasUnsavedChanges.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20))
                  : (_openBlock(), _createElementBlock("i", _hoisted_21)),
                _createTextVNode(" Save ")
              ], 10, _hoisted_17)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})